const UploadingIndicator = () => {
  return (
    <div className="d-flex align-items-center gap-1 ms-2 mb-1">
      <p className="fw-bold">Please wait while uploading</p>
      {[...Array(8)].map((_, i) => (
        <div
          key={i}
          className="spinner-grow spinner-grow-sm"
          role="status"
          style={{ height: "5px", width: "5px" }}
        />
      ))}
    </div>
  );
};

export default UploadingIndicator;
